export default "__VITE_ASSET__a70dKeCc__"